/* eslint-disable import/no-cycle */
import { FlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/FlujoTesoreriaReadingFiltersDto"
import { ESTADO_CONCILIACION } from "api/Types/EstadoConciliacion"
import { TIPO_FLUJO_TESORERIA } from "api/Types/TipoFlujoTesoreria"
import { QUERY_PARAMETERS } from "common/constants"
import TesoreriaService from "common/services/TesoreriaService"
import { PAYMENT_TYPE } from "common/utils/constants"
import { DOC_TYPES_KEYS } from "features/User/pages/ApprovalsManagement/constants"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"

export const ConciliableLabel = (
  t: TFunction,
  rowData: FlujoTesoreriaReadingFiltersDtoProps | undefined,
  setShowModalConciliacion: Dispatch<
    SetStateAction<{
      show: boolean
      data: FlujoTesoreriaReadingFiltersDtoProps | undefined
    }>
  >
) => {
  if (!rowData?.conciliacion) return

  const { conciliacion } = rowData

  const isClickable =
    conciliacion.estado === ESTADO_CONCILIACION.CONCILIADO ||
    conciliacion.estado === ESTADO_CONCILIACION.EXCLUIDO

  const labelKey =
    conciliacion.estado === ESTADO_CONCILIACION.CONCILIADO
      ? "bancos.statusConciliacion.conciled"
      : conciliacion.estado === ESTADO_CONCILIACION.SIN_CONCILIAR
      ? "bancos.statusConciliacion.notConciled"
      : "bancos.statusConciliacion.excluido"

  const handleClick = () =>
    setShowModalConciliacion({ show: true, data: rowData })

  return (
    <span
      onClick={isClickable ? handleClick : undefined}
      className={
        isClickable
          ? "tw-cursor-pointer tw-text-info-100 tw-no-underline hover:tw-underline"
          : "tw-text-text"
      }
    >
      {t(labelKey)}
    </span>
  )
}

export const DocumentoAsociadoAsiento = (
  cell: FlujoTesoreriaReadingFiltersDtoProps,
  handleOpenDocumentoModal: (id: string) => void
) => {
  return (
    <span
      onClick={async () => {
        const idDocumento = cell?.facturaId

        if (!idDocumento) return
        handleOpenDocumentoModal(idDocumento)
      }}
      className={` ${
        cell?.facturaId
          ? "tw-text-info hover:tw-underline tw-cursor-pointer"
          : ""
      }`}
    >
      {cell?.documento ?? "-"}
    </span>
  )
}

export const getToggleButtons = (
  setTabSelected: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return [
    {
      id: 1,
      handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[2].value),
      label: "Pagos",
      disabled: false,
    },
    {
      id: 2,
      handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[18].value),
      label: "Cobros",
      disabled: false,
    },
  ]
}

export const PERSONALIZADO_OPTION = "Personalizado"

export const DEFAULT_INITIAL_QUERY_PARAMETER = `${QUERY_PARAMETERS.MaxResultCount}=20`

export const handleCreateQueryConfig = (
  queryKey: $TSMigrationFixMe,
  queryValue: $TSMigrationFixMe
) => {
  return {
    key: queryKey,
    query: queryValue,
  }
}

export const PAYMENT_TYPE_PAGOS_COBROS_ACTION_SETTINGS = () => {
  return {
    [TIPO_FLUJO_TESORERIA.COBRO]: {
      // CLIENTE
      label: "Cartera de cobro",
      title: "Cobro",
      postService: TesoreriaService.createCobro,
      postFacturaService: TesoreriaService.createCobroDeFactura,
      putService: TesoreriaService.editCobro,
      putRemesableService: TesoreriaService.editCobroRemesable,
      deleteService: TesoreriaService.deleteCobro,
      value: PAYMENT_TYPE.COBRO,
    },
    [TIPO_FLUJO_TESORERIA.PAGO]: {
      // PROVEEDOR
      label: "Cartera de pago",
      title: "Pago",
      postService: TesoreriaService.createPago,
      postFacturaService: TesoreriaService.createPagoDeFactura,
      putService: TesoreriaService.editPago,
      putRemesableService: TesoreriaService.editPagoRemesable,
      deleteService: TesoreriaService.deletePago,
      value: PAYMENT_TYPE.PAGO,
    },
  }
}

export const getTransformedPagosYRemesas = (array: $TSMigrationFixMe) => {
  const transformedArray = array?.map((document: $TSMigrationFixMe) => {
    if (document.tipo === 2) {
      return { ...document, importe: document.importe * -1 }
    }
    return document
  })
  return transformedArray
}
